import React from 'react';
import './SiteList.css';

const SiteList = ({ sites, activeSite, onSiteSelect, onEditSite, onViewLocations, onViewMembers, onDeleteSite, membersCount = 0 }) => {
  if (!sites || sites.length === 0) {
    return (
      <div className="site-list empty">
        <div className="empty-state">
          <div className="empty-icon">🏢</div>
          <h3>No tienes centros de entrenamiento creados</h3>
          <p>Crea tu primer centro de entrenamiento para comenzar a administrar tu dojo</p>
        </div>
      </div>
    );
  }

  // Separar sites principales y sucursales
  const mainSites = sites.filter(site => !site.parent_site_id);
  const branchSites = sites.filter(site => site.parent_site_id);
  
  // Calcular total de ubicaciones de todos los sites
  const totalLocations = sites.reduce((total, site) => {
    return total + (site.locations?.length || 0);
  }, 0);

  const getParentSiteName = (parentSiteId) => {
    const parentSite = sites.find(site => site.id === parentSiteId);
    return parentSite ? parentSite.name : 'Centro Padre';
  };


  const formatSports = (site) => {
    if (site.sports && Array.isArray(site.sports) && site.sports.length > 0) {
      return `${site.sports.length} deportes (IDs: ${site.sports.join(', ')})`;
    }
    return 'Sin deportes definidos';
  };

  return (
    <div className="site-list">
      <div className="sites-grid">
        {mainSites.map(site => (
              <div 
                key={site.id} 
                className={`site-card ${activeSite?.id === site.id ? 'active' : ''}`}
                onClick={() => onSiteSelect(site)}
              >
                <div className="site-header">
                  <h4 className="site-name">{site.name}</h4>
                  <div className="site-badges">
                    <span className="badge main">Principal</span>
                    {activeSite?.id === site.id && (
                      <span className="badge active">Activo</span>
                    )}
                  </div>
                </div>
                
                <p className="site-description">
                  {site.description || 'Sin descripción'}
                </p>
                
                <div className="site-details">
                  <div className="detail-row">
                    <span className="detail-label">🏃‍♂️</span>
                    <span className="detail-value">{formatSports(site)}</span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">📍</span>
                    <span className="detail-value">
                      {site.locations?.length || 0} ubicación{(site.locations?.length || 0) !== 1 ? 'es' : ''}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">👥</span>
                    <span className="detail-value">
                      {membersCount || 0} miembro{(membersCount || 0) !== 1 ? 's' : ''}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">📅</span>
                    <span className="detail-value">
                      Creado: {new Date(site.created_at || Date.now()).toLocaleDateString()}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">🏢</span>
                    <span className="detail-value">
                      {site.parent_site_id ? 'Sucursal' : 'Centro Principal'}
                    </span>
                  </div>
                </div>
                
                <div className="site-actions">
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditSite(site);
                    }}
                    className="btn btn-warning btn-sm"
                  >
                    ✏️ Editar
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewLocations(site);
                    }}
                    className="btn btn-primary btn-sm"
                  >
                    📍 Ver Ubicaciones
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewMembers(site);
                    }}
                    className="btn btn-secondary btn-sm"
                  >
                    👥 Ver Miembros
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSite(site);
                    }}
                    className="btn btn-danger btn-sm"
                  >
                    🗑️ Eliminar
                  </button>
                </div>
              </div>
            ))}
        
        {/* Sucursales */}
      {branchSites.length > 0 && (
        <div className="sites-section">
          <h3 className="section-title">
            <span className="icon">🏪</span>
            Sucursales
          </h3>
          <div className="sites-grid">
            {branchSites.map(site => (
              <div 
                key={site.id} 
                className={`site-card branch ${activeSite?.id === site.id ? 'active' : ''}`}
                onClick={() => onSiteSelect(site)}
              >
                <div className="site-header">
                  <h4 className="site-name">{site.name}</h4>
                  <div className="site-badges">
                    <span className="badge branch">Sucursal</span>
                    {activeSite?.id === site.id && (
                      <span className="badge active">Activo</span>
                    )}
                  </div>
                </div>
                
                <p className="site-description">
                  {site.description || 'Sin descripción'}
                </p>
                
                <div className="site-details">
                  <div className="detail-row">
                    <span className="detail-label">🏢</span>
                    <span className="detail-value">
                      {getParentSiteName(site.parent_site_id)}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">🏃‍♂️</span>
                    <span className="detail-value">{formatSports(site)}</span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">📍</span>
                    <span className="detail-value">
                      {site.locations?.length || 0} ubicación{(site.locations?.length || 0) !== 1 ? 'es' : ''}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">👥</span>
                    <span className="detail-value">
                      {membersCount || 0} miembro{(membersCount || 0) !== 1 ? 's' : ''}
                    </span>
                  </div>
                  
                  <div className="detail-row">
                    <span className="detail-label">📅</span>
                    <span className="detail-value">
                      Creado: {new Date(site.created_at || Date.now()).toLocaleDateString()}
                    </span>
                  </div>
                </div>
                
                <div className="site-actions">
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditSite(site);
                    }}
                    className="btn btn-warning btn-sm"
                  >
                    ✏️ Editar
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewLocations(site);
                    }}
                    className="btn btn-primary btn-sm"
                  >
                    📍 Ver Ubicaciones
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onViewMembers(site);
                    }}
                    className="btn btn-secondary btn-sm"
                  >
                    👥 Ver Miembros
                  </button>
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSite(site);
                    }}
                    className="btn btn-danger btn-sm"
                  >
                    🗑️ Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      </div>

      {/* Resumen */}
      <div className="sites-summary">
        <div className="summary-card">
          <h4>Resumen</h4>
          <div className="summary-stats">
            <div className="stat">
              <div className="stat-icon">🏢</div>
              <span className="stat-number">{sites.length}</span>
              <span className="stat-label">Cantidad de centros</span>
            </div>
            <div className="stat">
              <div className="stat-icon">📍</div>
              <span className="stat-number">{totalLocations}</span>
              <span className="stat-label">Ubicaciones</span>
            </div>
            <div className="stat">
              <div className="stat-icon">👥</div>
              <span className="stat-number">{membersCount}</span>
              <span className="stat-label">Miembros</span>
            </div>
            <div className="stat">
              <div className="stat-icon">📅</div>
              <span className="stat-number">
                {sites.reduce((total, site) => {
                  if (site.locations && Array.isArray(site.locations)) {
                    return total + site.locations.reduce((siteTotal, location) => {
                      if (location.practice_schedules && Array.isArray(location.practice_schedules)) {
                        return siteTotal + location.practice_schedules.length;
                      }
                      return siteTotal;
                    }, 0);
                  }
                  return total;
                }, 0)}
              </span>
              <span className="stat-label">Horarios</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteList;
